import { render } from "./fu.vue?vue&type=template&id=204eb6de&scoped=true"
import script from "./fu.vue?vue&type=script&lang=js"
export * from "./fu.vue?vue&type=script&lang=js"

import "./fu.vue?vue&type=style&index=0&id=204eb6de&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-204eb6de"]])

export default __exports__